<template>
  <form @submit.prevent="$emit('submit')">
    <div class="-mb-8 -mr-6 flex flex-wrap p-8">
      <text-input
        v-model="form.user.first_name"
        :errors="form.errors.first_name"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Prenume"
      />
      <text-input
        v-model="form.user.last_name"
        :errors="form.errors.last_name"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Nume"
      />
      <text-input
        v-model="form.user.email"
        :errors="form.errors.email"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Email"
      />
      <div class="w-full pb-8 pr-6 lg:w-1/2">
        <label class="form-label" for="text-input-pass">Parola:</label>
        <Password
          v-model="form.user.password"
          name="password"
          :feedback="false"
          toggle-mask
          class="w-full"
          pt:pcinputtext:root:class="form-input focus:border-indigo-400 focus:ring-2"
          pt:pcinputtext:root:id="text-input-pass"
        />
        <div v-if="form.errors.password?.length" class="form-error">
          {{ form.errors.password[0] }}
        </div>
      </div>
      <text-input
        v-model="form.user.telephone"
        :errors="form.errors.telephone"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Telefon"
      />
      <text-input
        v-model="form.user.company"
        :errors="form.errors.company"
        class="w-full pb-8 pr-6 lg:w-1/2"
        label="Companie"
      />
    </div>
    <slot />
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue';
import { Password } from 'primevue';

export default {
  components: {
    TextInput,
    Password,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
